import * as React from 'react';
import { currencyMap } from '../helpers/priceHelpers';
import { numberFormatter } from '../helpers/TranslationService';

export const getCurrencyString = (price: number, currency: string, fixRuble: boolean = true) => {
    const formattedPrice = numberFormatter.format(parseInt((price as any) as string, 10));

    switch (currency) {
        case 'EUR':
            return `${formattedPrice} ${currencyMap.EUR}`;
        case 'BRL':
            return `${currencyMap.BRL} ${formattedPrice}`;
        case 'CNY':
            return `${currencyMap.CNY} ${formattedPrice}`;
        case 'AUD':
            return `${currencyMap.AUD}${formattedPrice}`;
        case 'USD':
            return `${currencyMap.USD}${formattedPrice}`;
        case 'RUB':
            // Since Ruble symbol is not loading with current font,
            // for now will just overwrite for RU
            return fixRuble ? (
                <>
                    {formattedPrice}{' '}
                    <span style={{ fontFamily: 'Helvetica Neue' }}>{currencyMap.RUB}</span>
                </>
            ) : (
                `${formattedPrice} ${currencyMap.RUB}`
            );
        default:
            return `${formattedPrice} ${currencyMap.EUR}`;
    }
};

interface IPriceString {
    price: number;
    countryCode?: string;
    currency?: string;
    prefix?: string;
    discount?: number;
    discountThreshold?: number;
}

export function PriceString({ price, currency, prefix = null }: IPriceString) {
    return (
        <span>
            {prefix ? `${prefix} ` : null}
            {getCurrencyString(Math.floor(price), currency)}
        </span>
    );
}
